import useSearchInstructor from "@modules/new-explore/hooks/useSearchInstructor";
import { Checkbox } from "@shared/components/checkbox";
import Input from "@shared/components/input/Input";
import { INPUT_SIZE } from "@shared/components/input";
import MagnifierIcon from "@svg/explore/magnifer";
import CloseRemoveIcon from "@svg/new-design/close-remove";
import { FC, useRef, useState } from "react";

const InstructorFilter: FC = () => {
  const {
    value,
    handleClear,
    onChangeDebounced,
    loading,
    resultItem,
    instructorIds,
    handleSelectedInstructor,
    search,
  } = useSearchInstructor();

  const [isInputFocused, setIsInputFocused] = useState(false);
  const filterParentRef = useRef<HTMLDivElement>(null);

  const inputFocusHandler = () => {
    setIsInputFocused(true);

    const sidebarContainer = filterParentRef.current?.closest(
      ".sidebarScroll"
    ) as HTMLElement;

    if (sidebarContainer && filterParentRef.current) {
      const containerRect = sidebarContainer.getBoundingClientRect();
      const relativeTop = containerRect.bottom;

      setTimeout(() => {
        sidebarContainer.scrollTo({
          top: relativeTop,
          behavior: "smooth",
        });
      }, 250);
    }
  };

  return (
    <div ref={filterParentRef}>
      <div
        className={
          isInputFocused && !resultItem.length
            ? "min-h-[120px] !duration-0"
            : "!duration-0"
        }
      >
        <Input
          startIcon={MagnifierIcon}
          startIconClassName="text-fds-icon-tertiary  h-5    w-5"
          value={value}
          endIconClassName="text-fds-icon-secondary h-5    w-5"
          endIconAction={handleClear}
          startIconAction={() => search(value)}
          endIcon={value?.length ? CloseRemoveIcon : undefined}
          placeholder="جستجو کنید..."
          onChange={(e) => onChangeDebounced(e.currentTarget.value)}
          size={INPUT_SIZE.MEDIUM}
          name="instructor"
          required={false}
          onFocus={inputFocusHandler}
          onBlur={() => setIsInputFocused(false)}
        />
        <div className="flex flex-col mt-3  lg:mb-0 mb-20  max-h-screen lg:!max-h-[200px] instructorScroll overflow-y-auto">
          {resultItem.length
            ? resultItem.map((resItem) => (
                <Checkbox
                  key={resItem.id}
                  id={String(resItem.id)}
                  label={resItem.full_name}
                  selected={
                    instructorIds?.findIndex(
                      (insItm) => Number(insItm.id) === resItem.id
                    ) !== -1
                      ? "checked"
                      : "unChecked"
                  }
                  handleOnChange={handleSelectedInstructor}
                  className="md:py-1.5  py-2  text-fds-icon-secondary"
                />
              ))
            : loading && (
                <p className="body-md text-fds-secondary">نتیجه‌ای یافت نشد.</p>
              )}
        </div>
      </div>
    </div>
  );
};

export default InstructorFilter;
